import { getLicenseFeatures } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'

const GET_LICENSE_FEATURES_QK = 'getLicenseFeaturesQueryKey'

export const useGetLicenseFeatures = (isEnabled: boolean) => {
  const { data: licenseFeatures, isFetched } = useQuery({
    queryKey: [GET_LICENSE_FEATURES_QK],
    queryFn: getLicenseFeatures,
    enabled: isEnabled,
  })

  return { licenseFeatures, isFetched }
}
